export const javascriptTagRegexGet =
  /<!-- Javascript Tag -->(.*?)<!-- \/Javascript Tag -->/s;
export const JAVASCRIPT_TAG_PLACEHOLDER =
  "<!-- Javascript Tag --><!-- /Javascript Tag -->";
